var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner_img"},_vm._l((_vm.bannerImg),function(item,index){return (_vm.BannerType==item.type)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.image),expression:"item.image"}],key:index}):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }